export const audioBufferToMp3 = (audioBuffer) => {
    const numChannels = audioBuffer.numberOfChannels;
    const bufferLength = audioBuffer.length * numChannels * 2 + 44;
    const arrayBuffer = new ArrayBuffer(bufferLength);
    const dataView = new DataView(arrayBuffer);
    const channelsData = [];
    let index, sample, offset = 0, position = 0;
    writeUint32(0x46464952); // "RIFF"
    writeUint32(bufferLength - 8); // file length - 8
    writeUint32(0x45564157); // "WAVE"
    writeUint32(0x20746d66); // "fmt " chunk
    writeUint32(16); // length = 16
    writeUint16(1); // PCM (uncompressed)
    writeUint16(numChannels);
    writeUint32(audioBuffer.sampleRate);
    writeUint32(audioBuffer.sampleRate * 2 * numChannels); // avg. bytes/sec
    writeUint16(numChannels * 2); // block-align
    writeUint16(16); // 16-bit
    writeUint32(0x61746164); // "data" - chunk
    writeUint32(bufferLength - position - 4); // chunk length
    for (index = 0; index < audioBuffer.numberOfChannels; index++) {
        channelsData.push(audioBuffer.getChannelData(index));
    }
    while (position < bufferLength) {
        for (index = 0; index < numChannels; index++) {
            sample = Math.max(-1, Math.min(1, channelsData[index][offset]));
            sample = (0.5 + sample < 0 ? sample * 32768 : sample * 32767) | 0;
            dataView.setInt16(position, sample, true);
            position += 2;
        }
        offset++;
    }
    function writeUint16(data) {
        dataView.setUint16(position, data, true);
        position += 2;
    }
    function writeUint32(data) {
        dataView.setUint32(position, data, true);
        position += 4;
    }
    return convertWavToMp3(arrayBuffer);
};
const convertWavToMp3 = (wavData) => {
    const mp3Chunks = [];
    const samplesPerFrame = 1152;
    if (!window.lamejs) {
        throw Error('Missing lameJsLibrary');
    }
    const wavHeader = window.lamejs.WavHeader.readHeader(new DataView(wavData));
    const mp3encoder = new window.lamejs.Mp3Encoder(wavHeader.channels, wavHeader.sampleRate, 128);
    const wavSamples = new Int16Array(wavData, wavHeader.dataOffset, wavHeader.dataLen / 2);
    if (wavHeader.channels === 1) {
        for (let i = 0; i < wavSamples.length; i += samplesPerFrame) {
            const mono = wavSamples.subarray(i, i + samplesPerFrame);
            const mp3buffer = mp3encoder.encodeBuffer(mono);
            if (mp3buffer.length > 0) {
                mp3Chunks.push(mp3buffer);
            }
        }
    }
    else {
        const leftSplit = [];
        const rightSplit = [];
        for (let i = 0; i < wavSamples.length; i += 2) {
            leftSplit.push(wavSamples[i]);
            rightSplit.push(wavSamples[i + 1]);
        }
        const left = new Int16Array(leftSplit);
        const right = new Int16Array(rightSplit);
        for (let i = 0; i < left.length; i += samplesPerFrame) {
            const leftChunk = left.subarray(i, i + samplesPerFrame);
            const rightChunk = right.subarray(i, i + samplesPerFrame);
            const mp3buf = mp3encoder.encodeBuffer(leftChunk, rightChunk);
            if (mp3buf.length > 0) {
                mp3Chunks.push(mp3buf);
            }
        }
    }
    const finalBuffer = mp3encoder.flush();
    if (finalBuffer.length > 0) {
        mp3Chunks.push(new Int8Array(finalBuffer));
    }
    return new Blob(mp3Chunks, { type: 'audio/mp3' });
};
